import createSingle from "./create-single.js";
import restoreRevision from "./restore-revision.js";
import promoteVersion from "./promote-version.js";

export default {
	createSingle,
	restoreRevision,
	promoteVersion,
};
